import { PaginationData } from 'shared/types';
import request from './requesters/document.request';
import { UploadFileCustom } from 'features/documents/components/DocumentForm/FileUpload';
import { DocumentProductLine, Documents, DocumentStatus } from '../models';
import { CancellationReason } from '../models';

type IsRegulQuotationResponse = {
  isRegul: boolean;
  dateRegul?: string | null;
};

const documentService = {
  getDocuments: (params: object) => request.get<PaginationData<Documents>>('/documents', { params }),
  getDocumentTypes: (params?: object) => request.get<PaginationData<DocumentType>>('/document-types', { params }),
  getDocumentStatus: (params?: object) => request.get<DocumentStatus[]>('/document-statuses', { params }),
  getDocumentProductLinePrestationStatus: (params?: object) =>
    request.get<PaginationData<Documents>>('/document-product-line-prestation-statuses', { params }),
  findDocument: (documentId: number | string, params?: object) => request.get(`/document/${documentId}`, { params }),
  getDocumentRegulAssociation: (documentId: number | string) =>
    request.get<{ documentId: number; hasRegul: boolean; regulCount: number }>(
      `/document/${documentId}/regul-association`,
    ),
  findDocumentsByParams: (params: object) => request.get(`/documents`, { params }),
  createDocument: (data: object) => request.post<Documents & { success?: boolean; error?: string }>('/documents', data),
  updateDocument: (documentId: number, data: object) =>
    request.put<Documents & { success?: boolean; error?: string }>(`/documents/${documentId}`, data),
  updateDocumentComment: (documentId: number, data: object) =>
    request.put<Documents>(`/document-update-comment/${documentId}`, data),
  deleteDocument: (documentId: number) => request.delete(`/document/${documentId}`),
  uploadFileToSalesorder: (file_upload: UploadFileCustom, salesorder_id?: string | number) =>
    request.post(`/document-file-uploads`, { ...file_upload, documentId: salesorder_id }),
  deleteFileToSalesorder: (id: string | number) => request.delete(`/document-file-uploads/${id}`),
  getDocumentProductLines: (params?: object) =>
    request.get<PaginationData<DocumentProductLine>>('/document-product-line', { params }),
  createEstimateAndOrder: (data: object) =>
    request.post<Documents & { success?: boolean; error?: string }>('/documents/create-estimate-and-order', data),
  countExpeditionRotations: (params?: { clientOrderId: number; booksProductLineId: string }) =>
    request.get<{ total: number }>(`/documents/expedition-rotations/count`, { params }),
  updateStatusDocument: (documentId: number, data: object) => request.put(`/document/${documentId}/status`, data),
  createExpedition: (data: object) => request.post('/expedition', data),
  getCancellationReasons: (params?: object) => request.get<CancellationReason[]>(`/cancellation-reasons`, { params }),
  cancelDocument: (documentId: number, data: object) => request.put(`/documents/${documentId}/cancel`, data),
  getServiceProviderIdFromBoOrderId: (params?: object) =>
    request.get(`/get-service-provider-id-from-bo-order-id`, { params }),
  getExpeditionHistory: (expeditionId: number) => request.get(`/expedition-history/${expeditionId}`),
  isRegulQuotation: (quotationOrderId: number) =>
    request.get<IsRegulQuotationResponse>(`/quotation/${quotationOrderId}/is-regul`),
};

export default documentService;
